import {TransitionHookType} from 'commonTypes'
import store from 'redux/config'
import {jobRequestAC} from '../../redux/jobRequests/jobRequests.duck'
import {RouterStates} from 'router/states/routerStates.enum'

const {dispatch} = store

export const jobRequestCleanup: TransitionHookType = {
  criteria: {
    from: RouterStates.jobRequests,
    to: state => state?.name !== RouterStates.jobRequests,
  },
  callback: () => {
    dispatch(jobRequestAC.cleanup())
  },
}
